/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown> }} Dialogue_List_Export_Event_Same_TimeInputs */

const en_dialogue_list_export_event_same_time = /** @type {(inputs: Dialogue_List_Export_Event_Same_TimeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Event ${i?.index} has the same start and end time.
 Would you like to ABORT your export?`)
};

const fr_dialogue_list_export_event_same_time = /** @type {(inputs: Dialogue_List_Export_Event_Same_TimeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`L'événement ${i?.index} a la même heure de début et de fin.
 Souhaitez-vous ABANDONNER l'exportation ?`)
};

const de_dialogue_list_export_event_same_time = /** @type {(inputs: Dialogue_List_Export_Event_Same_TimeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Das Ereignis ${i?.index} hat dieselbe Start- und Endzeit.
Möchten Sie den Export abbrechen?`)
};

const it_dialogue_list_export_event_same_time = /** @type {(inputs: Dialogue_List_Export_Event_Same_TimeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`L'evento ${i?.index} ha la stessa ora di inizio e fine.
Vuoi ANNULLARE l'esportazione?`)
};

const ru_dialogue_list_export_event_same_time = /** @type {(inputs: Dialogue_List_Export_Event_Same_TimeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Событие ${i?.index} имеет одинаковое время начала и окончания.
Вы хотите ОТМЕНИТЬ экспорт?`)
};

const es_dialogue_list_export_event_same_time = /** @type {(inputs: Dialogue_List_Export_Event_Same_TimeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`El evento ${i?.index} tiene la misma hora de inicio y de fin.
¿Desea cancelar la exportación?`)
};

const zh_cn2_dialogue_list_export_event_same_time = /** @type {(inputs: Dialogue_List_Export_Event_Same_TimeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`事件 ${i?.index} 的开始时间和结束时间相同。

是否要中止导出操作？`)
};

const ja_dialogue_list_export_event_same_time = /** @type {(inputs: Dialogue_List_Export_Event_Same_TimeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`イベント ${i?.index} の開始時刻と終了時刻は同じです。
エクスポートを中止しますか?`)
};

const hi_dialogue_list_export_event_same_time = /** @type {(inputs: Dialogue_List_Export_Event_Same_TimeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`इवेंट ${i?.index} का प्रारंभ और समाप्ति समय समान है।
क्या आप अपना निर्यात रद्द करना चाहेंगे?`)
};

const pt_pt2_dialogue_list_export_event_same_time = /** @type {(inputs: Dialogue_List_Export_Event_Same_TimeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`O evento ${i?.index} tem o mesmo horário de início e término.
Deseja CANCELAR a exportação?`)
};

/**
* | output |
* | --- |
* | "Event {index} has the same start and end time. Would you like to ABORT your export?" |
*
* @param {Dialogue_List_Export_Event_Same_TimeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const dialogue_list_export_event_same_time = /** @type {((inputs: Dialogue_List_Export_Event_Same_TimeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialogue_List_Export_Event_Same_TimeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_dialogue_list_export_event_same_time(inputs)
	if (locale === "de") return de_dialogue_list_export_event_same_time(inputs)
	if (locale === "it") return it_dialogue_list_export_event_same_time(inputs)
	if (locale === "ru") return ru_dialogue_list_export_event_same_time(inputs)
	if (locale === "es") return es_dialogue_list_export_event_same_time(inputs)
	if (locale === "zh-CN") return zh_cn2_dialogue_list_export_event_same_time(inputs)
	if (locale === "ja") return ja_dialogue_list_export_event_same_time(inputs)
	if (locale === "hi") return hi_dialogue_list_export_event_same_time(inputs)
	if (locale === "pt-PT") return pt_pt2_dialogue_list_export_event_same_time(inputs)
	return en_dialogue_list_export_event_same_time(inputs)
});